import React from "react";
import confs from "../../configurations";
import { useAuth } from "../Auth/useAuth";
import { useCart } from "../Carts/useCart";
import useTranslations from "../Translations/useTranslations";
import theme from "../ui/theme";
import UiBadge, { UI_BADGE_TYPE } from "../ui/UiBadge";
import UiTag, { UI_TAG_TYPE } from "../ui/UiTag";
import "./ArticleGeneriqueCard.css";
const { URL_GED } = confs;

const ArticleGeneriqueCard = ({
  articleG,
  showArticles,
  loading,
  itemsInCart,
  isPack,
}) => {
  const [{ user }] = useAuth();
  const [{ current_cart }] = useCart(user.client_profile?.id);
  const trl = useTranslations();

  const packArt = current_cart.packs.find(
    (pack) =>
      pack.name ===
      trl.data.message("GEN", "CODGEN", articleG.CODGEN, "LIBGEN"),
  );

  function ArticleCardHeader() {
    const isPackArticle = () => {
      const packDiscount = () => {
        if (articleG.mt_remise > 0) {
          return (
            <React.Fragment>
              <UiTag
                content={`-${articleG.mt_remise} €`}
                uiTagType={UI_TAG_TYPE.highlightColor}
                bold={700}
              />
            </React.Fragment>
          );
        }
      };
      const totalPackQuantity = () => {
        if (packArt && packArt.qte_commande > 0) {
          return (
            <React.Fragment>
              <UiBadge
                content={packArt.qte_commande}
                badgeUiType={[UI_BADGE_TYPE.SMALL]}
                classNames={["mr-2"]}
              />
            </React.Fragment>
          );
        }
      };
      return (
        <React.Fragment>
          <div className="d-flex align-items-center ">
            {totalPackQuantity()}
            <UiTag
              content={
                <React.Fragment>
                  <div className=" d-flex gap-1 align-items-center">
                    <span>PACK</span>
                  </div>
                </React.Fragment>
              }
              uiTagType={UI_TAG_TYPE.successColor}
              bold={700}
            />
          </div>
          <div>{packDiscount()}</div>
        </React.Fragment>
      );
    };

    const isStandardArticle = () => {
      const articleDiscount = () => {
        if (articleG.remise_fixe > 0) {
          return (
            <React.Fragment>
              <UiTag
                content={`-${articleG.remise_fixe}%`}
                uiTagType={UI_TAG_TYPE.highlightColor}
                bold={700}
              />
            </React.Fragment>
          );
        }
      };
      const totalArticleQuantity = () => {
        if (itemsInCart > 0) {
          return (
            <React.Fragment>
              <UiBadge
                content={itemsInCart}
                badgeUiType={[UI_BADGE_TYPE.SMALL]}
                classNames={["mr-2"]}
              />
            </React.Fragment>
          );
        }
      };
      return (
        <React.Fragment>
          <div>{totalArticleQuantity()}</div>
          <div>{articleDiscount()}</div>
        </React.Fragment>
      );
    };

    const renderTopHeaderContent = isPack ? isPackArticle : isStandardArticle;

    return (
      <React.Fragment>
        <div className="article_container py-2 px-2">
          {renderTopHeaderContent()}
        </div>
      </React.Fragment>
    );
  }

  function renderProductImage() {
    const imgSrc = `${URL_GED}/Generiques/${articleG.CODGEN}/${articleG.CODGEN}-e.jpg`;
    const fallbackSrc = "/background-picture-not-found-2.svg";
    const onError = ({ currentTarget }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = fallbackSrc;
    };
    return (
      <React.Fragment>
        <img
          className="product_img"
          src={imgSrc}
          onError={onError}
          alt="Generiques"
        />
      </React.Fragment>
    );
  }

  function fetchingArticle() {
    if (!loading) return null;
    return (
      <React.Fragment>
        <span className="d-block ml-2">
          <svg
            fill={theme.primary}
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="16px"
            height="16px"
            viewBox="0 0 128 128"
          >
            <g>
              <path
                d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z"
                id="loader-svg"
                fillOpacity="1"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 64 64"
                to="360 64 64"
                dur="1000ms"
                repeatCount="indefinite"
              ></animateTransform>
            </g>
          </svg>
        </span>
      </React.Fragment>
    );
  }

  function renderProductDetails() {
    return (
      <React.Fragment>
        <div className="product_details d-flex align-items-center justify-content-center text-center px-2 flex-column">
          <span>
            {trl.data.message("GEN", "CODGEN", articleG.CODGEN, "LIBGEN")}
          </span>
          {fetchingArticle()}
        </div>
      </React.Fragment>
    );
  }

  function showArticlesModal(e) {
    e.preventDefault();
    e.stopPropagation();
    showArticles();
  }

  const mainFrameStyle = {
    ...theme.neumorphicOutset,
    borderRadius: 3,
    height: "100%",
    maxWidth: "15.5rem",
  };

  return (
    <div
      style={mainFrameStyle}
      className="article_card_container mb-4 "
      onClick={showArticlesModal}
    >
      <div className="product_card d-flex flex-column h-100">
        {ArticleCardHeader()}
        {renderProductImage()}
        {renderProductDetails()}
      </div>
    </div>
  );
};

export default ArticleGeneriqueCard;
